<template>
  <div>
    <div class="entete border-entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">
                {{ $t('listeLotPaiement.titreRecette') }}
              </h1>
              <breadcrumb :breadcrumb="breadcrumb" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <store-recherche-provider
      key="lotPaiementRecette"
      :name="constantes.storeName"
      :copy="remiseBancaireStore"
      :copyChanges="changesLotPaiementStore">
      <liste-lot-paiement
        :referenceTable="referenceTable"
        :permissions="constantes.LOT_PAIEMENT_RECETTE"
        :moduleDcf="constantes.MODULE_TLPE"
        :nameStore="constantes.storeName">
      </liste-lot-paiement>
    </store-recherche-provider>
  </div>
</template>

<script>
import remiseBancaireStore from '@/store/modules/remiseBancaire';
import breadcrumb from '@/components/general/breadcrumb';
import { MODULE_TLPE } from '@/configuration/devisConf';
import { LOT_PAIEMENT_RECETTE } from '@/configuration/gabed/permissionsGabedConf';
import { REFERENCE_TABLE_LOT_PAIEMENT_RECETTE } from '@/configuration/general/referenceTableConf';
import genererCritereRechercheLotPaiementRecette from '@/services/gabed/lotDePaiementRecette/genererCritereRechercheLotPaiementRecette';
import storeRechercheProvider from '@/components/general/store/storeRechercheProvider';
import { LOT_PAIEMENT_RECETTE_STORE } from '@/configuration/gabed/tlpe/tlpeConf';
import * as allTypes from '@/store/mutation-type';
import listeLotPaiement from '@/components/lotPaiement/listeLotPaiement';

export default {
  components: {
    breadcrumb,
    listeLotPaiement,
    storeRechercheProvider,
  },
  data() {
    return {
      constantes: {
        LOT_PAIEMENT_RECETTE,
        MODULE_TLPE,
        storeName: LOT_PAIEMENT_RECETTE_STORE,
      },
      referenceTable: REFERENCE_TABLE_LOT_PAIEMENT_RECETTE,
      remiseBancaireStore,
    };
  },
  computed: {
    breadcrumb() {
      return [
        { title: this.$t('listeLotPaiement.breadcrumb.accueil'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('listeLotPaiement.titreRecette'), route: '', isActive: true },
      ];
    },
    changesLotPaiementStore() {
      return {
        state: {
          items: [],
          total: 0,
          critereRechercheLotPaiement: genererCritereRechercheLotPaiementRecette(),
        },
        mutations: {
          [allTypes.RESET_STATE](state) {
            const s = {
              items: [],
              total: 0,
              critereRechercheLotPaiement: genererCritereRechercheLotPaiementRecette(),
            };
            Object.keys(state).forEach(key => {
              state[key] = s[key];
            });
          },
        },
      };
    },
  },
  mounted() {
    this.setInformationPage(this.$t('pagePatrimoine.lotPaiementRecette.liste'));
  },
};
</script>
